import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ExamsResolutionAnswerKey } from '../exams-resolution/exams-resolution-answer-key';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Sheet, SheetBody, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import usePermission from '@/hooks/usePermission';
import { TableCell, TableRow } from '@/components/ui/table';

export default function ExamMetricsUserListItem(props) {
  const { t } = useTranslation();
  const { examStudent, exam } = props;
  const navigate = useNavigate();

  const avatarImage = examStudent?.user?.image?.url;
  const avatarImageMemo = React.useMemo(() => avatarImage, [avatarImage]);
  const [showModal, setShowModal] = useState(false);

  // último envio do aluno pela data de finalização
  const lastUserAttempt = examStudent?.user?.['question-books-users']?.sort((a, b) => new Date(b?.['finished-at']) - new Date(a?.['finished-at']))[0];

  const getStatusBadge = status => {
    switch (status) {
      case 'waiting_correction':
      case 'waiting-correction':
        return { label: 'Aguardando correção', variant: 'warning' };
      case 'reviews':
      case 'review':
        return { label: 'Em correção', variant: 'warning' };
      case 'approved':
        return { label: 'Aprovado', variant: 'success' };
      case 'disapproved':
        return { label: 'Reprovado', variant: 'danger' };
      case 'accepting_answers':
        return { label: 'Aceitando respostas', variant: 'neutral' };
      case 'corrected':
        return { label: 'Corrigido', variant: 'success' };
      default:
        return { label: '--', variant: 'neutral' };
    }
  };

  const hasPermissionToCorrect = usePermission('Corrigir questões discursivas', 'Provas e simulados');

  return (
    <>
      <TableRow>
        <TableCell>
          <div className="round-dg__user">
            <Link
              to={`/usuario/metricas/${examStudent?.user?.id}`}
              state={{ isRedirected: true }}
            >
              <AvatarWrapper
                src={avatarImageMemo}
                text={examStudent?.user?.name}
                className="size-9"
              />
            </Link>

            <div className="round-dg__user-inner">
              <h3
                className="round-dg__title font-bold text-primary-dark"
                title={examStudent?.user?.name}
              >
                <Link
                  to={`/usuario/metricas/${examStudent?.user?.id}`}
                  state={{ isRedirected: true }}
                >
                  {examStudent?.user?.name}
                </Link>
              </h3>
            </div>
          </div>
        </TableCell>

        <TableCell>{moment(lastUserAttempt['finished-at']).format('DD/MM/YYYY') != 'Invalid date' ? moment(lastUserAttempt['finished-at']).format('DD/MM/YYYY') : '--'}</TableCell>

        <TableCell>{lastUserAttempt?.['corrected-by'] || '--'}</TableCell>

        <TableCell>{parseFloat(lastUserAttempt.score).toFixed(2) != 'NaN' ? parseFloat(lastUserAttempt.score).toFixed(2) : '--'}</TableCell>

        <TableCell>
          <Badge
            variant={getStatusBadge(lastUserAttempt?.['correction-status']).variant}
            size="xs"
          >
            {getStatusBadge(lastUserAttempt?.['correction-status']).label}
          </Badge>
        </TableCell>

        {exam.visibility !== 'open' && (
          <TableCell>
            <Badge
              variant={getStatusBadge(lastUserAttempt?.status).variant}
              size="xs"
            >
              {getStatusBadge(lastUserAttempt?.status).label}
            </Badge>
          </TableCell>
        )}

        <TableCell>
          <div className="flex gap-2">
            {/* Botão de corrigir questão discursiva disponível se:
              - O usuário tiver permissão para corrigir questões discursivas (hasPermissionToCorrect = true)
              - A avaliação tiver questão discursiva (exam?.['has-discursive'] = true)
              - Estiver com status de aguardando correção ou em correção
            */}
            {hasPermissionToCorrect && exam?.['has-discursive'] && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate(`/correcao-discursiva/${lastUserAttempt['question-book-id']}/${examStudent?.id}/${lastUserAttempt?.id}`)}
              >
                {lastUserAttempt?.['correction-status'] === 'waiting_correction' || lastUserAttempt?.['correction-status'] === 'review' ? t('button.correctDiscursive') : t('button.viewCorrection')}
              </Button>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowModal(true)}
            >
              {t('button.answerKey')}
            </Button>
          </div>
        </TableCell>
      </TableRow>

      <Sheet
        open={showModal}
        onOpenChange={setShowModal}
      >
        <SheetContent size="md">
          <SheetBody className="pb-6 pt-12">
            <ExamsResolutionAnswerKey
              examId={exam.id}
              examData={examStudent.user['question-books-users']}
              amountQuestions={exam['question-count']}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    </>
  );
}
